import React from "react";
import {
  Form,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormInput
} from "shards-react";

export default () => (
  <div className="main-navbar__search w-100 px-4 d-none d-md-flex d-lg-flex"></div>
/*
  <Form className="main-navbar__search w-100 px-4 d-none d-md-flex d-lg-flex">
    <InputGroup seamless className="ml-2">
      <InputGroupAddon type="prepend">
        <InputGroupText>
          
        </InputGroupText>
      </InputGroupAddon>
      <FormInput
        className="navbar-search"
        placeholder=""
      />
    </InputGroup>
  </Form>
*/
);
